import React, {useState, useEffect} from "react";
import SVG from "react-inlinesvg";
import SimpleTable from "my-simple-react-table";
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import * as handlers from "../../../../../_redux/selected-user/selectedUserHandlers";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import TableSkeleton from "../../../../../../../util/TableSkeleton";
import {formatStatus, formatDate, permissionCssClass} from "../../../../../../../util/Helpers";
import ViewDocumentModal from "./modal/ViewDocumentModal";
import UploadDocumentModal from "./modal/UploadDocumentModal";
import { Permissions, PermissionType } from "../../../../../../../util/Permissions";

const Documents = props => {

    const adminUser = useSelector(state => state.auth.user);
    /* Get User documents from redux */
    const [documents, notification] = useSelector(({selectedUser}) => [selectedUser.data?.documents, selectedUser.notification], shallowEqual);

    /* Documents Modal State Management */
    const [documentModal, setDocumentModal] = useState({showViewDocumentModal: false, showUploadDocumentModal: false, details: null});

    // Redux dispatch
    const dispatch = useDispatch();

    /* Fetch User Documents on success notification */
    useEffect(() => {
      if (notification?.type === "success"){
          dispatch(handlers.fetchUserDocuments(props.match.params.userId));
      }
    }, [dispatch, notification, props.match.params.userId]);

    /* Fetch User Documents */
    useEffect(() => {
        dispatch(handlers.fetchUserDocuments(props.match.params.userId));
    }, [dispatch, props.match.params.userId]);


    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setDocumentModal({...documentModal, [modal]: !documentModal[modal]})
    }

    /* Document Type Column */
    const formatCategory = row => {
        return <div className="d-flex align-items-center" style={{whiteSpace: "nowrap"}}>

                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/files/jpg.svg")}
                        />
                    </span>
                    <div>
                        <span className=" mb-1 font-size-lg">
                            {row.type?.replace(/_/g, " ")}
                        </span>
                    </div>
                </div>
    }

    /* View Document */
    const viewDocument = id => {
        const details = documents.filter(document => id === document.documentId)[0];
        setDocumentModal({...documentModal, showViewDocumentModal: true, details});
    }

    /* View Document Button */
    const documentButton = row => {

        return  <button
                    className="btn btn-icon btn-white btn-hover-primary btn-sm mx-0"
                    onClick={_ => viewDocument(row.documentId)}
                    >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                        title="View payment"
                        src={toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")}
                        />
                    </span>
                </button>
    }
    
    return  <div className="card card-custom gutter-b">
                <div className="row">
                    <div className="col-12">
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                {/* <!--begin::Title--> */}
                                <div className="card-title pt-5 w-100">
                                    <h3 className="card-label">
                                        <span className="d-block text-dark h3 font-weight-bolder">Documents</span>
                                        <span className="d-block text-muted mt-2 font-size-sm">User uploaded docuents</span>
                                    </h3>
                                    <div className={`card-toolbar ml-auto ${permissionCssClass(adminUser, Permissions.DOCUMENTS, PermissionType.CREATE)}`}>
                                        <button 
                                            className="btn btn-primary font-weight-bolder font-size-sm"
                                            onClick={toggleModal("showUploadDocumentModal")}
                                        >
                                            <span className="svg-icon svg-icon-md svg-icon-white">
                                                <SVG
                                                    title=" "
                                                    src={toAbsoluteUrl("/media/svg/icons/Files/Uploaded-file.svg")}
                                                />
                                            </span>
                                            New Document
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-0">
                                {
                                    documents ?
                                        <SimpleTable
                                            data={documents}
                                            columns={[
                                                        {title:"CATEGORY", format: formatCategory},
                                                        {title:"TYPE", key: "idType"},
                                                        {title:"STATUS", format: row => formatStatus(row.status)},
                                                        {title: "DATE", format: row => formatDate(row.created)},
                                                        {title: "", format: documentButton}
                                                    ]} 
                                        />
                                        :
                                        <TableSkeleton/>
                                }
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                    </div>
                </div>
                {
                    documentModal.showViewDocumentModal &&
                        <ViewDocumentModal 
                            key={documentModal?.details?.documentId} 
                            {...documentModal} 
                            onHide={toggleModal("showViewDocumentModal")}
                        />
                }

                <UploadDocumentModal  
                    key={(new Date()).toTimeString()}
                    {...props}
                    {...documentModal} 
                    onHide={toggleModal("showUploadDocumentModal")}
                />

            </div>
}

export default Documents;